import { css } from 'styled-components'
import styled from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.foreground};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 20px 20px 30px 10px;
  `}
`

export const TextAreaContainer = styled.div`
  flex: 1;
`

export const TextInput = styled.input`
  ${({ theme }) => css`
    background-color: ${theme.colors.inputTextBackground};
    color: ${theme.colors.text};
    border: 1px solid ${theme.colors.text};
  `}
  border-radius: 20px;
  font-size: 16px;
  padding: 10px;
  width: 100%;
`
